import { LANDING_PAGE_EVENTS } from "@/constants/amplitude.constants";
import Amplitude from "@/shared/services/amplitude.service";
import {
  getCurrentURL,
  getReferrer,
  getScreenWidth,
} from "@/shared/utils/commons";
import { getUTMFieldsFromLocalStorage } from "@/shared/utils/utm.util";
import { faAngleDown, faAngleUp } from "@fortawesome/pro-solid-svg-icons";
import { Icon } from "@graphy/ui";
import classNames from "classnames";
import { useState } from "react";

type AccordianPropsType = {
  id: number;
  title: string;
  body: string;
  isOpen: boolean;
  onToggle: (id: number) => void;
};

export const Accordian = (props: AccordianPropsType) => {
  const { id, title, body, isOpen, onToggle } = props;

  return (
    <div className="flex flex-col ">
      <div
        className={classNames(
          "flex cursor-pointer items-center justify-between gap-2.5 bg-purple-0 px-4 py-2 sm:px-6 sm:py-3",
          {
            "rounded-t-xl border border-b-0 border-grey-2": isOpen,
            "rounded-xl border border-transparent": !isOpen,
          }
        )}
        onClick={() => onToggle(id)}
      >
        <h4 className="text-title-14 text-grey-4 sm:text-title-16">{title}</h4>
        <div className="h-4 w-4 basis-4">
          <Icon icon={isOpen ? faAngleUp : faAngleDown} size="xs" />
        </div>
      </div>
      {isOpen && (
        <div className="bottom-shadow-purple-xl rounded-b-xl border border-t-0 border-grey-2 px-6 py-4">
          <p className="text-body-14 text-grey-4">{body}</p>
        </div>
      )}
    </div>
  );
};

type AccordianGroupPropsType = {
  allowMultipleOpen?: boolean;
  data: {
    id: number;
    title: string;
    body: string;
  }[];
};

const AccordianGroup = (props: AccordianGroupPropsType) => {
  const [openAccordians, setOpenAccordians] = useState<{
    [key: number]: boolean;
  }>({});

  const toggleAccordian = (id: number) => {
    if (!openAccordians[id]) {
      // Trigger lp_faq_expanded
      const { current_url, screen_width, referrer, utm_params, faq_title } =
        LANDING_PAGE_EVENTS.FAQ_EXPANDED.PROPERTIES;

      new Amplitude().sendEvent({
        type: LANDING_PAGE_EVENTS.FAQ_EXPANDED.LABEL,
        properties: {
          [current_url]: getCurrentURL(),
          [screen_width]: getScreenWidth(),
          [referrer]: getReferrer(),
          [utm_params]: getUTMFieldsFromLocalStorage(),
          [faq_title]: props.data[id]?.title,
        } as { [key: string]: string },
      });
    }
    if (props.allowMultipleOpen) {
      setOpenAccordians({ ...openAccordians, [id]: !openAccordians[id] });
    } else {
      setOpenAccordians({ [id]: !openAccordians[id] });
    }
  };

  return (
    <div className="flex flex-grow flex-col gap-4">
      {props.data.map(({ id, title, body }) => (
        <Accordian
          key={id}
          id={id}
          title={title}
          body={body}
          isOpen={Boolean(openAccordians[id])}
          onToggle={toggleAccordian}
        />
      ))}
    </div>
  );
};

export default AccordianGroup;
